import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getThresholdData } from '@store/noc/threshold/actions';
import { setAllThresholdCellSelection } from '@store/noc/base/actions';
import { allThresholdCellSelectionSelector } from '@store/noc/base/selectors';
import ThresholdContainer from './ThresholdContainer';

export const selector = createSelector(
  allThresholdCellSelectionSelector,
  (allThresholdCellSelectionStore) => ({
    allCellSelection: allThresholdCellSelectionStore,
  }),
);

export default connect(selector, {
  getThresholdData,
  setAllThresholdCellSelection,
})(ThresholdContainer);
